import React from 'react';
import { useMachineData } from './hooks/useMachineData';
import Header from './components/Header';
import Dashboard from './components/Dashboard';

const DAYS_PT = ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'];
const MONTHS_PT = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];

function formatDatePT(d: Date): string {
  return `${DAYS_PT[d.getDay()]}, ${d.getDate()} de ${MONTHS_PT[d.getMonth()]} de ${d.getFullYear()}`;
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <span className="footer-text">{formatDatePT(new Date())}</span>
        <span className="footer-text">·</span>
        <span className="footer-text">Turno Manhã · 07:00–13:00</span>
      </div>
      <span className="footer-version">OnGears v1.0</span>
    </footer>
  );
}

export default function App() {
  const { machines, kpis, lastUpdate } = useMachineData();

  return (
    <div className="app">
      <Header kpis={kpis} />
      <Dashboard machines={machines} kpis={kpis} lastUpdate={lastUpdate}  />
      <Footer />
    </div>
  );
}
